enum WorkspaceMilestoneStatus {
  draft = 'draft',
  active = 'active',
  archived = 'archived',
  completed = 'completed',
  failed = 'failed',
}

export default WorkspaceMilestoneStatus
